import React, { useRef, useState } from "react";
import whats_new from "../../assets/images/whats_new.svg";
import redirect from "../../assets/images/redirect.svg";
import { clickOutside } from "../../reusable/common";
import { dashboardColors, theme } from "../../themes/Theme";
import revampData from '../../data/revampData.json';
import moment from "moment";
const WhatsNewPopup = ({isManageEventsPage = false , isInternationalConditionTrue = false , isNotInternationalConditionTrue = false}) => {
  const [openWhatsNewPopup, setWhatsNewPopup] = useState(false);
  const productUpdates = revampData?.data?.listWhatsNewPage?.data;
  const sortedUpdates = productUpdates  ?  [...productUpdates].sort((a, b) =>
    moment(b?.date)?.toDate() - moment(a?.date)?.toDate()
  ) : [];

  const wrapperRef = useRef("menu");
  clickOutside(wrapperRef, () => {
    setWhatsNewPopup(false);
  });
  return (
    <>
      <div ref={wrapperRef}>
       <span
        onClick={() => setWhatsNewPopup(!openWhatsNewPopup)}
        className="ml-3 richtext-cursor-pointer"
      >
        <img src={whats_new} alt="whats_new" />
      </span>

        {openWhatsNewPopup && (
          <div className="WhatsNewPopup-container  position-absolute">
            <div >
              <p className="WhatsNew-title mb-0">What’s New</p>
            </div>
            <div className="WhatsNew-scrollable px-2">
              {sortedUpdates?.map((item) => (
                
                  <div key={item?.id} className="WhatsNew-item">
                    <a href={item?.link} target="_blank" className="cursor-pointer text-decoration-none" rel="noopener noreferrer">
                    <div className="d-flex justify-content-between">
                      <p className="WhatsNew-date">{moment(item?.date)?.format("D MMMM YYYY")}</p>
                      <img src={redirect} alt="redirect-icon" />
                    </div>
                      <p className="WhatsNew-heading">{item?.title}</p>
                      <p className="WhatsNew-description">{item?.description}</p>
                    </a>
                  </div>
               
              ))}
            </div>
            <div className="WhatsNew-footer py-3 d-flex richtext-justify-end text-end p-2">
              <a
                href="https://dev.konfhub.com/whats-new"
                target="_blank"
                rel="noopener noreferrer"
                className="k-btn cancel-btn mr-0 mr-sm-3 mt-3 mt-sm-0 "
              >
                Discover What’s New
              </a>

            </div></div>
        )}
      </div>
      <style jsx>
        {`
          .WhatsNewPopup-container {
            z-index: 1030 !important;
            min-width: 260px;
            max-width: 450px;
            width: 100%;
            background: #fff !important;
            right: ${isManageEventsPage ? "123px" : isNotInternationalConditionTrue ? "159px" : "161px" }  !important;
            border-radius: 6px;
            top: ${isManageEventsPage ? "62px" : isNotInternationalConditionTrue ? "113px" : " 78px"} ;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
            text-align : start;
          }
          .WhatsNew-title{
            font-size:18px;
            font-weight:500;
            color: ${dashboardColors[theme].primaryTextColor};
            border-bottom: 0.5px solid #C3CDDF;
            padding: 14px;
          }
          .WhatsNew-scrollable {
            max-height: 330px;
            overflow-y: auto;
          }
          .WhatsNew-item {
            padding: 12px 16px;
            border-bottom: 0.5px solid #e6e9ef;
          }
          .WhatsNew-item:hover {
            background-color: #ECF2FF;
          }
          .WhatsNew-item:last-child {
            border-bottom: none;
          }
          .WhatsNew-date {
            font-size: 12px;
            color: #8B8D98;
            margin-bottom: 4px;
          }
          .WhatsNew-heading {
            font-size: 16px;
            font-weight: 600;
            margin: 0 0 4px 0;
            color: ${dashboardColors[theme].primaryTextColor};
          }
          .WhatsNew-description {
            font-size: 14px;
            color: ${dashboardColors[theme].primaryTextColor};
            margin: 0;
            line-height: 1.4;
          }
          .WhatsNew-footer a:hover{
              text-decoration: none;
              color: ${dashboardColors[theme].primary};
          }
        `}
      </style>
    </>
  );
};

export default WhatsNewPopup;
